import React, { PropTypes } from 'react';
import DemoImage from '../DemoImage';

const noop = () => undefined;

const CustomCdnImage = ({image, transformation, cdnCode}) =>
    (
        <div className="cdn-direct-image-container">
            <DemoImage
                publicId={image.public_id}
                transformation={{ height: '50', crop: 'thumb', dpr: 'auto' }}
                privateCdn
                cname={`idemo-${cdnCode}.cloudinary.com`}
                secureDistribution={`idemo-${cdnCode}.cloudinary.com`}
                showDetails={noop}
                showButton={false}
                hideLoading
                className="cdn-direct-image"
                />
        </div>
    );

CustomCdnImage.PropTypes = {
    image: PropTypes.string.isRequired,
    transformation: PropTypes.object.isRequired,
    cdnCode: PropTypes.string.isRequired
};

export default CustomCdnImage;


/** WEBPACK FOOTER **
 ** ./src/js/components/MultiCdn/CustomCdnImage.js
 **/